export enum EntitlementGrantStatus {
  Active = 0,
  Expired = 1,
  Revoked = 2,
}

export enum EntitlementType {
  Pass = 0,
  Membership = 1,
}

export interface EntitlementSummary {
  dailyMinutesAllowance: number;
  bookAheadHours: number;
  expiresAt: string | null; // ISO-8601 datetime, or null until activated
  status: EntitlementGrantStatus;
  /** 0 = Pass, 1 = Membership. Optional: absent on older API responses;
   *  consumers default to Pass when undefined. Arrives as an integer. */
  type?: EntitlementType;
}
